/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedClaimRouteImport } from './routes/_authed/claim'
import { Route as AuthedLinkRouteImport } from './routes/_authed/link'
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile'
import { Route as AuthedSearchRouteImport } from './routes/_authed/search'
import { Route as AuthedSettingsRouteRouteImport } from './routes/_authed/settings/route'
import { Route as AuthedWatchlistRouteImport } from './routes/_authed/watchlist'
import { Route as AuthConfirmEmailRouteImport } from './routes/auth/confirm-email'
import { Route as AuthDeletedRouteImport } from './routes/auth/deleted'
import { Route as AuthForgotRouteImport } from './routes/auth/forgot'
import { Route as AuthResetRouteImport } from './routes/auth/reset'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthedDiscoverIndexRouteImport } from './routes/_authed/discover.index'
import { Route as AuthedLibraryIndexRouteImport } from './routes/_authed/library.index'
import { Route as AuthedProfileHistoryRouteImport } from './routes/_authed/profile_.history'
import { Route as AuthedSettingsIndexRouteImport } from './routes/_authed/settings/index'
import { Route as AuthedSettingsAccountRouteImport } from './routes/_authed/settings/account'
import { Route as AuthedSettingsDevicesRouteImport } from './routes/_authed/settings/devices'
import { Route as AuthedSettingsPlayerRouteImport } from './routes/_authed/settings/player'
import { Route as AuthedSettingsQualityRouteImport } from './routes/_authed/settings/quality'
import { Route as AuthedSettingsSecurityRouteImport } from './routes/_authed/settings/security'
import { Route as AuthedSettingsSharingRouteImport } from './routes/_authed/settings/sharing'
import { Route as AuthedSettingsTraktRouteImport } from './routes/_authed/settings/trakt'
import { Route as AuthedClaimApproveCodeRouteImport } from './routes/_authed/claim_.approve.$code'
import { Route as AuthedDiscoverMediaTypeTmdbIdRouteImport } from './routes/_authed/discover.$mediaType.$tmdbId'
import { Route as AuthedDiscoverPersonPersonIdRouteImport } from './routes/_authed/discover.person.$personId'
import { Route as AuthedItemSourceIdItemIdRouteImport } from './routes/_authed/item.$sourceId.$itemId'
import { Route as AuthedLibrarySourceIdLibraryIdRouteImport } from './routes/_authed/library.$sourceId.$libraryId'
import { Route as AuthedPlayerSourceIdItemIdRouteImport } from './routes/_authed/player.$sourceId.$itemId'
import { Route as AuthedSettingsSharingUserIdRouteImport } from './routes/_authed/settings/sharing_.$userId'
import { Route as AuthedSettingsServerServerIdIndexRouteImport } from './routes/_authed/settings/server.$serverId.index'
import { Route as AuthedSettingsServerServerIdActivityRouteImport } from './routes/_authed/settings/server.$serverId.activity'
import { Route as AuthedSettingsServerServerIdDashboardRouteImport } from './routes/_authed/settings/server.$serverId.dashboard'
import { Route as AuthedSettingsServerServerIdGeneralRouteImport } from './routes/_authed/settings/server.$serverId.general'
import { Route as AuthedSettingsServerServerIdLibrariesRouteImport } from './routes/_authed/settings/server.$serverId.libraries'
import { Route as AuthedSettingsServerServerIdLibraryRouteImport } from './routes/_authed/settings/server.$serverId.library'
import { Route as AuthedSettingsServerServerIdMetadataRouteImport } from './routes/_authed/settings/server.$serverId.metadata'
import { Route as AuthedSettingsServerServerIdNetworkRouteImport } from './routes/_authed/settings/server.$serverId.network'
import { Route as AuthedSettingsServerServerIdOpensubtitlesRouteImport } from './routes/_authed/settings/server.$serverId.opensubtitles'
import { Route as AuthedSettingsServerServerIdTasksRouteImport } from './routes/_authed/settings/server.$serverId.tasks'
import { Route as AuthedSettingsServerServerIdTranscoderRouteImport } from './routes/_authed/settings/server.$serverId.transcoder'
import { Route as AuthedSettingsServerServerIdTroubleshootingRouteImport } from './routes/_authed/settings/server.$serverId.troubleshooting'
import { Route as AuthedDiscoverTvTmdbIdSeasonSeasonNumberRouteImport } from './routes/_authed/discover.tv.$tmdbId.season.$seasonNumber'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClaimRoute = AuthedClaimRouteImport.update({
  id: '/claim',
  path: '/claim',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLinkRoute = AuthedLinkRouteImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSearchRoute = AuthedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRouteRoute = AuthedSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWatchlistRoute = AuthedWatchlistRouteImport.update({
  id: '/watchlist',
  path: '/watchlist',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthConfirmEmailRoute = AuthConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthDeletedRoute = AuthDeletedRouteImport.update({
  id: '/deleted',
  path: '/deleted',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthedDiscoverIndexRoute = AuthedDiscoverIndexRouteImport.update({
  id: '/discover/',
  path: '/discover/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLibraryIndexRoute = AuthedLibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileHistoryRoute = AuthedProfileHistoryRouteImport.update({
  id: '/profile_/history',
  path: '/profile/history',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsIndexRoute = AuthedSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsAccountRoute = AuthedSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsDevicesRoute = AuthedSettingsDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsPlayerRoute = AuthedSettingsPlayerRouteImport.update({
  id: '/player',
  path: '/player',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsQualityRoute = AuthedSettingsQualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsSecurityRoute = AuthedSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsSharingRoute = AuthedSettingsSharingRouteImport.update({
  id: '/sharing',
  path: '/sharing',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsTraktRoute = AuthedSettingsTraktRouteImport.update({
  id: '/trakt',
  path: '/trakt',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedClaimApproveCodeRoute = AuthedClaimApproveCodeRouteImport.update({
  id: '/claim_/approve/$code',
  path: '/claim/approve/$code',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDiscoverMediaTypeTmdbIdRoute =
  AuthedDiscoverMediaTypeTmdbIdRouteImport.update({
    id: '/discover/$mediaType/$tmdbId',
    path: '/discover/$mediaType/$tmdbId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDiscoverPersonPersonIdRoute =
  AuthedDiscoverPersonPersonIdRouteImport.update({
    id: '/discover/person/$personId',
    path: '/discover/person/$personId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedItemSourceIdItemIdRoute =
  AuthedItemSourceIdItemIdRouteImport.update({
    id: '/item/$sourceId/$itemId',
    path: '/item/$sourceId/$itemId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedLibrarySourceIdLibraryIdRoute =
  AuthedLibrarySourceIdLibraryIdRouteImport.update({
    id: '/library/$sourceId/$libraryId',
    path: '/library/$sourceId/$libraryId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPlayerSourceIdItemIdRoute =
  AuthedPlayerSourceIdItemIdRouteImport.update({
    id: '/player/$sourceId/$itemId',
    path: '/player/$sourceId/$itemId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsSharingUserIdRoute =
  AuthedSettingsSharingUserIdRouteImport.update({
    id: '/sharing_/$userId',
    path: '/sharing/$userId',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdIndexRoute =
  AuthedSettingsServerServerIdIndexRouteImport.update({
    id: '/server/$serverId/',
    path: '/server/$serverId/',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdActivityRoute =
  AuthedSettingsServerServerIdActivityRouteImport.update({
    id: '/server/$serverId/activity',
    path: '/server/$serverId/activity',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdDashboardRoute =
  AuthedSettingsServerServerIdDashboardRouteImport.update({
    id: '/server/$serverId/dashboard',
    path: '/server/$serverId/dashboard',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdGeneralRoute =
  AuthedSettingsServerServerIdGeneralRouteImport.update({
    id: '/server/$serverId/general',
    path: '/server/$serverId/general',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdLibrariesRoute =
  AuthedSettingsServerServerIdLibrariesRouteImport.update({
    id: '/server/$serverId/libraries',
    path: '/server/$serverId/libraries',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdLibraryRoute =
  AuthedSettingsServerServerIdLibraryRouteImport.update({
    id: '/server/$serverId/library',
    path: '/server/$serverId/library',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdMetadataRoute =
  AuthedSettingsServerServerIdMetadataRouteImport.update({
    id: '/server/$serverId/metadata',
    path: '/server/$serverId/metadata',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdNetworkRoute =
  AuthedSettingsServerServerIdNetworkRouteImport.update({
    id: '/server/$serverId/network',
    path: '/server/$serverId/network',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdOpensubtitlesRoute =
  AuthedSettingsServerServerIdOpensubtitlesRouteImport.update({
    id: '/server/$serverId/opensubtitles',
    path: '/server/$serverId/opensubtitles',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdTasksRoute =
  AuthedSettingsServerServerIdTasksRouteImport.update({
    id: '/server/$serverId/tasks',
    path: '/server/$serverId/tasks',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdTranscoderRoute =
  AuthedSettingsServerServerIdTranscoderRouteImport.update({
    id: '/server/$serverId/transcoder',
    path: '/server/$serverId/transcoder',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsServerServerIdTroubleshootingRoute =
  AuthedSettingsServerServerIdTroubleshootingRouteImport.update({
    id: '/server/$serverId/troubleshooting',
    path: '/server/$serverId/troubleshooting',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedDiscoverTvTmdbIdSeasonSeasonNumberRoute =
  AuthedDiscoverTvTmdbIdSeasonSeasonNumberRouteImport.update({
    id: '/discover/tv/$tmdbId/season/$seasonNumber',
    path: '/discover/tv/$tmdbId/season/$seasonNumber',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteRouteWithChildren
  '/': typeof AuthedIndexRoute
  '/settings': typeof AuthedSettingsRouteRouteWithChildren
  '/claim': typeof AuthedClaimRoute
  '/link': typeof AuthedLinkRoute
  '/profile': typeof AuthedProfileRoute
  '/search': typeof AuthedSearchRoute
  '/watchlist': typeof AuthedWatchlistRoute
  '/auth/confirm-email': typeof AuthConfirmEmailRoute
  '/auth/deleted': typeof AuthDeletedRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/reset': typeof AuthResetRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/profile/history': typeof AuthedProfileHistoryRoute
  '/settings/account': typeof AuthedSettingsAccountRoute
  '/settings/devices': typeof AuthedSettingsDevicesRoute
  '/settings/player': typeof AuthedSettingsPlayerRoute
  '/settings/quality': typeof AuthedSettingsQualityRoute
  '/settings/security': typeof AuthedSettingsSecurityRoute
  '/settings/sharing': typeof AuthedSettingsSharingRoute
  '/settings/trakt': typeof AuthedSettingsTraktRoute
  '/discover/': typeof AuthedDiscoverIndexRoute
  '/library/': typeof AuthedLibraryIndexRoute
  '/settings/': typeof AuthedSettingsIndexRoute
  '/claim/approve/$code': typeof AuthedClaimApproveCodeRoute
  '/discover/$mediaType/$tmdbId': typeof AuthedDiscoverMediaTypeTmdbIdRoute
  '/discover/person/$personId': typeof AuthedDiscoverPersonPersonIdRoute
  '/item/$sourceId/$itemId': typeof AuthedItemSourceIdItemIdRoute
  '/library/$sourceId/$libraryId': typeof AuthedLibrarySourceIdLibraryIdRoute
  '/player/$sourceId/$itemId': typeof AuthedPlayerSourceIdItemIdRoute
  '/settings/sharing/$userId': typeof AuthedSettingsSharingUserIdRoute
  '/settings/server/$serverId/activity': typeof AuthedSettingsServerServerIdActivityRoute
  '/settings/server/$serverId/dashboard': typeof AuthedSettingsServerServerIdDashboardRoute
  '/settings/server/$serverId/general': typeof AuthedSettingsServerServerIdGeneralRoute
  '/settings/server/$serverId/libraries': typeof AuthedSettingsServerServerIdLibrariesRoute
  '/settings/server/$serverId/library': typeof AuthedSettingsServerServerIdLibraryRoute
  '/settings/server/$serverId/metadata': typeof AuthedSettingsServerServerIdMetadataRoute
  '/settings/server/$serverId/network': typeof AuthedSettingsServerServerIdNetworkRoute
  '/settings/server/$serverId/opensubtitles': typeof AuthedSettingsServerServerIdOpensubtitlesRoute
  '/settings/server/$serverId/tasks': typeof AuthedSettingsServerServerIdTasksRoute
  '/settings/server/$serverId/transcoder': typeof AuthedSettingsServerServerIdTranscoderRoute
  '/settings/server/$serverId/troubleshooting': typeof AuthedSettingsServerServerIdTroubleshootingRoute
  '/settings/server/$serverId/': typeof AuthedSettingsServerServerIdIndexRoute
  '/discover/tv/$tmdbId/season/$seasonNumber': typeof AuthedDiscoverTvTmdbIdSeasonSeasonNumberRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteRouteWithChildren
  '/claim': typeof AuthedClaimRoute
  '/link': typeof AuthedLinkRoute
  '/profile': typeof AuthedProfileRoute
  '/search': typeof AuthedSearchRoute
  '/watchlist': typeof AuthedWatchlistRoute
  '/auth/confirm-email': typeof AuthConfirmEmailRoute
  '/auth/deleted': typeof AuthDeletedRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/reset': typeof AuthResetRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/': typeof AuthedIndexRoute
  '/profile/history': typeof AuthedProfileHistoryRoute
  '/settings/account': typeof AuthedSettingsAccountRoute
  '/settings/devices': typeof AuthedSettingsDevicesRoute
  '/settings/player': typeof AuthedSettingsPlayerRoute
  '/settings/quality': typeof AuthedSettingsQualityRoute
  '/settings/security': typeof AuthedSettingsSecurityRoute
  '/settings/sharing': typeof AuthedSettingsSharingRoute
  '/settings/trakt': typeof AuthedSettingsTraktRoute
  '/discover': typeof AuthedDiscoverIndexRoute
  '/library': typeof AuthedLibraryIndexRoute
  '/settings': typeof AuthedSettingsIndexRoute
  '/claim/approve/$code': typeof AuthedClaimApproveCodeRoute
  '/discover/$mediaType/$tmdbId': typeof AuthedDiscoverMediaTypeTmdbIdRoute
  '/discover/person/$personId': typeof AuthedDiscoverPersonPersonIdRoute
  '/item/$sourceId/$itemId': typeof AuthedItemSourceIdItemIdRoute
  '/library/$sourceId/$libraryId': typeof AuthedLibrarySourceIdLibraryIdRoute
  '/player/$sourceId/$itemId': typeof AuthedPlayerSourceIdItemIdRoute
  '/settings/sharing/$userId': typeof AuthedSettingsSharingUserIdRoute
  '/settings/server/$serverId/activity': typeof AuthedSettingsServerServerIdActivityRoute
  '/settings/server/$serverId/dashboard': typeof AuthedSettingsServerServerIdDashboardRoute
  '/settings/server/$serverId/general': typeof AuthedSettingsServerServerIdGeneralRoute
  '/settings/server/$serverId/libraries': typeof AuthedSettingsServerServerIdLibrariesRoute
  '/settings/server/$serverId/library': typeof AuthedSettingsServerServerIdLibraryRoute
  '/settings/server/$serverId/metadata': typeof AuthedSettingsServerServerIdMetadataRoute
  '/settings/server/$serverId/network': typeof AuthedSettingsServerServerIdNetworkRoute
  '/settings/server/$serverId/opensubtitles': typeof AuthedSettingsServerServerIdOpensubtitlesRoute
  '/settings/server/$serverId/tasks': typeof AuthedSettingsServerServerIdTasksRoute
  '/settings/server/$serverId/transcoder': typeof AuthedSettingsServerServerIdTranscoderRoute
  '/settings/server/$serverId/troubleshooting': typeof AuthedSettingsServerServerIdTroubleshootingRoute
  '/settings/server/$serverId': typeof AuthedSettingsServerServerIdIndexRoute
  '/discover/tv/$tmdbId/season/$seasonNumber': typeof AuthedDiscoverTvTmdbIdSeasonSeasonNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/auth': typeof AuthRouteRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/_authed/settings': typeof AuthedSettingsRouteRouteWithChildren
  '/_authed/claim': typeof AuthedClaimRoute
  '/_authed/link': typeof AuthedLinkRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/search': typeof AuthedSearchRoute
  '/_authed/watchlist': typeof AuthedWatchlistRoute
  '/auth/confirm-email': typeof AuthConfirmEmailRoute
  '/auth/deleted': typeof AuthDeletedRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/reset': typeof AuthResetRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/profile_/history': typeof AuthedProfileHistoryRoute
  '/_authed/settings/account': typeof AuthedSettingsAccountRoute
  '/_authed/settings/devices': typeof AuthedSettingsDevicesRoute
  '/_authed/settings/player': typeof AuthedSettingsPlayerRoute
  '/_authed/settings/quality': typeof AuthedSettingsQualityRoute
  '/_authed/settings/security': typeof AuthedSettingsSecurityRoute
  '/_authed/settings/sharing': typeof AuthedSettingsSharingRoute
  '/_authed/settings/trakt': typeof AuthedSettingsTraktRoute
  '/_authed/discover/': typeof AuthedDiscoverIndexRoute
  '/_authed/library/': typeof AuthedLibraryIndexRoute
  '/_authed/settings/': typeof AuthedSettingsIndexRoute
  '/_authed/claim_/approve/$code': typeof AuthedClaimApproveCodeRoute
  '/_authed/discover/$mediaType/$tmdbId': typeof AuthedDiscoverMediaTypeTmdbIdRoute
  '/_authed/discover/person/$personId': typeof AuthedDiscoverPersonPersonIdRoute
  '/_authed/item/$sourceId/$itemId': typeof AuthedItemSourceIdItemIdRoute
  '/_authed/library/$sourceId/$libraryId': typeof AuthedLibrarySourceIdLibraryIdRoute
  '/_authed/player/$sourceId/$itemId': typeof AuthedPlayerSourceIdItemIdRoute
  '/_authed/settings/sharing_/$userId': typeof AuthedSettingsSharingUserIdRoute
  '/_authed/settings/server/$serverId/activity': typeof AuthedSettingsServerServerIdActivityRoute
  '/_authed/settings/server/$serverId/dashboard': typeof AuthedSettingsServerServerIdDashboardRoute
  '/_authed/settings/server/$serverId/general': typeof AuthedSettingsServerServerIdGeneralRoute
  '/_authed/settings/server/$serverId/libraries': typeof AuthedSettingsServerServerIdLibrariesRoute
  '/_authed/settings/server/$serverId/library': typeof AuthedSettingsServerServerIdLibraryRoute
  '/_authed/settings/server/$serverId/metadata': typeof AuthedSettingsServerServerIdMetadataRoute
  '/_authed/settings/server/$serverId/network': typeof AuthedSettingsServerServerIdNetworkRoute
  '/_authed/settings/server/$serverId/opensubtitles': typeof AuthedSettingsServerServerIdOpensubtitlesRoute
  '/_authed/settings/server/$serverId/tasks': typeof AuthedSettingsServerServerIdTasksRoute
  '/_authed/settings/server/$serverId/transcoder': typeof AuthedSettingsServerServerIdTranscoderRoute
  '/_authed/settings/server/$serverId/troubleshooting': typeof AuthedSettingsServerServerIdTroubleshootingRoute
  '/_authed/settings/server/$serverId/': typeof AuthedSettingsServerServerIdIndexRoute
  '/_authed/discover/tv/$tmdbId/season/$seasonNumber': typeof AuthedDiscoverTvTmdbIdSeasonSeasonNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/'
    | '/settings'
    | '/claim'
    | '/link'
    | '/profile'
    | '/search'
    | '/watchlist'
    | '/auth/confirm-email'
    | '/auth/deleted'
    | '/auth/forgot'
    | '/auth/reset'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify'
    | '/profile/history'
    | '/settings/account'
    | '/settings/devices'
    | '/settings/player'
    | '/settings/quality'
    | '/settings/security'
    | '/settings/sharing'
    | '/settings/trakt'
    | '/discover/'
    | '/library/'
    | '/settings/'
    | '/claim/approve/$code'
    | '/discover/$mediaType/$tmdbId'
    | '/discover/person/$personId'
    | '/item/$sourceId/$itemId'
    | '/library/$sourceId/$libraryId'
    | '/player/$sourceId/$itemId'
    | '/settings/sharing/$userId'
    | '/settings/server/$serverId/activity'
    | '/settings/server/$serverId/dashboard'
    | '/settings/server/$serverId/general'
    | '/settings/server/$serverId/libraries'
    | '/settings/server/$serverId/library'
    | '/settings/server/$serverId/metadata'
    | '/settings/server/$serverId/network'
    | '/settings/server/$serverId/opensubtitles'
    | '/settings/server/$serverId/tasks'
    | '/settings/server/$serverId/transcoder'
    | '/settings/server/$serverId/troubleshooting'
    | '/settings/server/$serverId/'
    | '/discover/tv/$tmdbId/season/$seasonNumber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/claim'
    | '/link'
    | '/profile'
    | '/search'
    | '/watchlist'
    | '/auth/confirm-email'
    | '/auth/deleted'
    | '/auth/forgot'
    | '/auth/reset'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify'
    | '/'
    | '/profile/history'
    | '/settings/account'
    | '/settings/devices'
    | '/settings/player'
    | '/settings/quality'
    | '/settings/security'
    | '/settings/sharing'
    | '/settings/trakt'
    | '/discover'
    | '/library'
    | '/settings'
    | '/claim/approve/$code'
    | '/discover/$mediaType/$tmdbId'
    | '/discover/person/$personId'
    | '/item/$sourceId/$itemId'
    | '/library/$sourceId/$libraryId'
    | '/player/$sourceId/$itemId'
    | '/settings/sharing/$userId'
    | '/settings/server/$serverId/activity'
    | '/settings/server/$serverId/dashboard'
    | '/settings/server/$serverId/general'
    | '/settings/server/$serverId/libraries'
    | '/settings/server/$serverId/library'
    | '/settings/server/$serverId/metadata'
    | '/settings/server/$serverId/network'
    | '/settings/server/$serverId/opensubtitles'
    | '/settings/server/$serverId/tasks'
    | '/settings/server/$serverId/transcoder'
    | '/settings/server/$serverId/troubleshooting'
    | '/settings/server/$serverId'
    | '/discover/tv/$tmdbId/season/$seasonNumber'
  id:
    | '__root__'
    | '/auth'
    | '/_authed'
    | '/_authed/settings'
    | '/_authed/claim'
    | '/_authed/link'
    | '/_authed/profile'
    | '/_authed/search'
    | '/_authed/watchlist'
    | '/auth/confirm-email'
    | '/auth/deleted'
    | '/auth/forgot'
    | '/auth/reset'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify'
    | '/_authed/'
    | '/_authed/profile_/history'
    | '/_authed/settings/account'
    | '/_authed/settings/devices'
    | '/_authed/settings/player'
    | '/_authed/settings/quality'
    | '/_authed/settings/security'
    | '/_authed/settings/sharing'
    | '/_authed/settings/trakt'
    | '/_authed/discover/'
    | '/_authed/library/'
    | '/_authed/settings/'
    | '/_authed/claim_/approve/$code'
    | '/_authed/discover/$mediaType/$tmdbId'
    | '/_authed/discover/person/$personId'
    | '/_authed/item/$sourceId/$itemId'
    | '/_authed/library/$sourceId/$libraryId'
    | '/_authed/player/$sourceId/$itemId'
    | '/_authed/settings/sharing_/$userId'
    | '/_authed/settings/server/$serverId/activity'
    | '/_authed/settings/server/$serverId/dashboard'
    | '/_authed/settings/server/$serverId/general'
    | '/_authed/settings/server/$serverId/libraries'
    | '/_authed/settings/server/$serverId/library'
    | '/_authed/settings/server/$serverId/metadata'
    | '/_authed/settings/server/$serverId/network'
    | '/_authed/settings/server/$serverId/opensubtitles'
    | '/_authed/settings/server/$serverId/tasks'
    | '/_authed/settings/server/$serverId/transcoder'
    | '/_authed/settings/server/$serverId/troubleshooting'
    | '/_authed/settings/server/$serverId/'
    | '/_authed/discover/tv/$tmdbId/season/$seasonNumber'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/claim': {
      id: '/_authed/claim'
      path: '/claim'
      fullPath: '/claim'
      preLoaderRoute: typeof AuthedClaimRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/link': {
      id: '/_authed/link'
      path: '/link'
      fullPath: '/link'
      preLoaderRoute: typeof AuthedLinkRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/search': {
      id: '/_authed/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthedSearchRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/watchlist': {
      id: '/_authed/watchlist'
      path: '/watchlist'
      fullPath: '/watchlist'
      preLoaderRoute: typeof AuthedWatchlistRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/auth/confirm-email': {
      id: '/auth/confirm-email'
      path: '/confirm-email'
      fullPath: '/auth/confirm-email'
      preLoaderRoute: typeof AuthConfirmEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/deleted': {
      id: '/auth/deleted'
      path: '/deleted'
      fullPath: '/auth/deleted'
      preLoaderRoute: typeof AuthDeletedRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/forgot': {
      id: '/auth/forgot'
      path: '/forgot'
      fullPath: '/auth/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/reset': {
      id: '/auth/reset'
      path: '/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authed/discover/': {
      id: '/_authed/discover/'
      path: '/discover'
      fullPath: '/discover/'
      preLoaderRoute: typeof AuthedDiscoverIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/library/': {
      id: '/_authed/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof AuthedLibraryIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile_/history': {
      id: '/_authed/profile_/history'
      path: '/profile/history'
      fullPath: '/profile/history'
      preLoaderRoute: typeof AuthedProfileHistoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/': {
      id: '/_authed/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedSettingsIndexRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/account': {
      id: '/_authed/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthedSettingsAccountRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/devices': {
      id: '/_authed/settings/devices'
      path: '/devices'
      fullPath: '/settings/devices'
      preLoaderRoute: typeof AuthedSettingsDevicesRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/player': {
      id: '/_authed/settings/player'
      path: '/player'
      fullPath: '/settings/player'
      preLoaderRoute: typeof AuthedSettingsPlayerRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/quality': {
      id: '/_authed/settings/quality'
      path: '/quality'
      fullPath: '/settings/quality'
      preLoaderRoute: typeof AuthedSettingsQualityRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/security': {
      id: '/_authed/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthedSettingsSecurityRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/sharing': {
      id: '/_authed/settings/sharing'
      path: '/sharing'
      fullPath: '/settings/sharing'
      preLoaderRoute: typeof AuthedSettingsSharingRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/trakt': {
      id: '/_authed/settings/trakt'
      path: '/trakt'
      fullPath: '/settings/trakt'
      preLoaderRoute: typeof AuthedSettingsTraktRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/claim_/approve/$code': {
      id: '/_authed/claim_/approve/$code'
      path: '/claim/approve/$code'
      fullPath: '/claim/approve/$code'
      preLoaderRoute: typeof AuthedClaimApproveCodeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/discover/$mediaType/$tmdbId': {
      id: '/_authed/discover/$mediaType/$tmdbId'
      path: '/discover/$mediaType/$tmdbId'
      fullPath: '/discover/$mediaType/$tmdbId'
      preLoaderRoute: typeof AuthedDiscoverMediaTypeTmdbIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/discover/person/$personId': {
      id: '/_authed/discover/person/$personId'
      path: '/discover/person/$personId'
      fullPath: '/discover/person/$personId'
      preLoaderRoute: typeof AuthedDiscoverPersonPersonIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/item/$sourceId/$itemId': {
      id: '/_authed/item/$sourceId/$itemId'
      path: '/item/$sourceId/$itemId'
      fullPath: '/item/$sourceId/$itemId'
      preLoaderRoute: typeof AuthedItemSourceIdItemIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/library/$sourceId/$libraryId': {
      id: '/_authed/library/$sourceId/$libraryId'
      path: '/library/$sourceId/$libraryId'
      fullPath: '/library/$sourceId/$libraryId'
      preLoaderRoute: typeof AuthedLibrarySourceIdLibraryIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/player/$sourceId/$itemId': {
      id: '/_authed/player/$sourceId/$itemId'
      path: '/player/$sourceId/$itemId'
      fullPath: '/player/$sourceId/$itemId'
      preLoaderRoute: typeof AuthedPlayerSourceIdItemIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/sharing_/$userId': {
      id: '/_authed/settings/sharing_/$userId'
      path: '/sharing/$userId'
      fullPath: '/settings/sharing/$userId'
      preLoaderRoute: typeof AuthedSettingsSharingUserIdRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/': {
      id: '/_authed/settings/server/$serverId/'
      path: '/server/$serverId'
      fullPath: '/settings/server/$serverId/'
      preLoaderRoute: typeof AuthedSettingsServerServerIdIndexRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/activity': {
      id: '/_authed/settings/server/$serverId/activity'
      path: '/server/$serverId/activity'
      fullPath: '/settings/server/$serverId/activity'
      preLoaderRoute: typeof AuthedSettingsServerServerIdActivityRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/dashboard': {
      id: '/_authed/settings/server/$serverId/dashboard'
      path: '/server/$serverId/dashboard'
      fullPath: '/settings/server/$serverId/dashboard'
      preLoaderRoute: typeof AuthedSettingsServerServerIdDashboardRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/general': {
      id: '/_authed/settings/server/$serverId/general'
      path: '/server/$serverId/general'
      fullPath: '/settings/server/$serverId/general'
      preLoaderRoute: typeof AuthedSettingsServerServerIdGeneralRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/libraries': {
      id: '/_authed/settings/server/$serverId/libraries'
      path: '/server/$serverId/libraries'
      fullPath: '/settings/server/$serverId/libraries'
      preLoaderRoute: typeof AuthedSettingsServerServerIdLibrariesRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/library': {
      id: '/_authed/settings/server/$serverId/library'
      path: '/server/$serverId/library'
      fullPath: '/settings/server/$serverId/library'
      preLoaderRoute: typeof AuthedSettingsServerServerIdLibraryRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/metadata': {
      id: '/_authed/settings/server/$serverId/metadata'
      path: '/server/$serverId/metadata'
      fullPath: '/settings/server/$serverId/metadata'
      preLoaderRoute: typeof AuthedSettingsServerServerIdMetadataRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/network': {
      id: '/_authed/settings/server/$serverId/network'
      path: '/server/$serverId/network'
      fullPath: '/settings/server/$serverId/network'
      preLoaderRoute: typeof AuthedSettingsServerServerIdNetworkRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/opensubtitles': {
      id: '/_authed/settings/server/$serverId/opensubtitles'
      path: '/server/$serverId/opensubtitles'
      fullPath: '/settings/server/$serverId/opensubtitles'
      preLoaderRoute: typeof AuthedSettingsServerServerIdOpensubtitlesRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/tasks': {
      id: '/_authed/settings/server/$serverId/tasks'
      path: '/server/$serverId/tasks'
      fullPath: '/settings/server/$serverId/tasks'
      preLoaderRoute: typeof AuthedSettingsServerServerIdTasksRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/transcoder': {
      id: '/_authed/settings/server/$serverId/transcoder'
      path: '/server/$serverId/transcoder'
      fullPath: '/settings/server/$serverId/transcoder'
      preLoaderRoute: typeof AuthedSettingsServerServerIdTranscoderRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/server/$serverId/troubleshooting': {
      id: '/_authed/settings/server/$serverId/troubleshooting'
      path: '/server/$serverId/troubleshooting'
      fullPath: '/settings/server/$serverId/troubleshooting'
      preLoaderRoute: typeof AuthedSettingsServerServerIdTroubleshootingRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/discover/tv/$tmdbId/season/$seasonNumber': {
      id: '/_authed/discover/tv/$tmdbId/season/$seasonNumber'
      path: '/discover/tv/$tmdbId/season/$seasonNumber'
      fullPath: '/discover/tv/$tmdbId/season/$seasonNumber'
      preLoaderRoute: typeof AuthedDiscoverTvTmdbIdSeasonSeasonNumberRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthConfirmEmailRoute: typeof AuthConfirmEmailRoute
  AuthDeletedRoute: typeof AuthDeletedRoute
  AuthForgotRoute: typeof AuthForgotRoute
  AuthResetRoute: typeof AuthResetRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthConfirmEmailRoute: AuthConfirmEmailRoute,
  AuthDeletedRoute: AuthDeletedRoute,
  AuthForgotRoute: AuthForgotRoute,
  AuthResetRoute: AuthResetRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyRoute: AuthVerifyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthedSettingsRouteRouteChildren {
  AuthedSettingsAccountRoute: typeof AuthedSettingsAccountRoute
  AuthedSettingsDevicesRoute: typeof AuthedSettingsDevicesRoute
  AuthedSettingsPlayerRoute: typeof AuthedSettingsPlayerRoute
  AuthedSettingsQualityRoute: typeof AuthedSettingsQualityRoute
  AuthedSettingsSecurityRoute: typeof AuthedSettingsSecurityRoute
  AuthedSettingsSharingRoute: typeof AuthedSettingsSharingRoute
  AuthedSettingsTraktRoute: typeof AuthedSettingsTraktRoute
  AuthedSettingsIndexRoute: typeof AuthedSettingsIndexRoute
  AuthedSettingsSharingUserIdRoute: typeof AuthedSettingsSharingUserIdRoute
  AuthedSettingsServerServerIdActivityRoute: typeof AuthedSettingsServerServerIdActivityRoute
  AuthedSettingsServerServerIdDashboardRoute: typeof AuthedSettingsServerServerIdDashboardRoute
  AuthedSettingsServerServerIdGeneralRoute: typeof AuthedSettingsServerServerIdGeneralRoute
  AuthedSettingsServerServerIdLibrariesRoute: typeof AuthedSettingsServerServerIdLibrariesRoute
  AuthedSettingsServerServerIdLibraryRoute: typeof AuthedSettingsServerServerIdLibraryRoute
  AuthedSettingsServerServerIdMetadataRoute: typeof AuthedSettingsServerServerIdMetadataRoute
  AuthedSettingsServerServerIdNetworkRoute: typeof AuthedSettingsServerServerIdNetworkRoute
  AuthedSettingsServerServerIdOpensubtitlesRoute: typeof AuthedSettingsServerServerIdOpensubtitlesRoute
  AuthedSettingsServerServerIdTasksRoute: typeof AuthedSettingsServerServerIdTasksRoute
  AuthedSettingsServerServerIdTranscoderRoute: typeof AuthedSettingsServerServerIdTranscoderRoute
  AuthedSettingsServerServerIdTroubleshootingRoute: typeof AuthedSettingsServerServerIdTroubleshootingRoute
  AuthedSettingsServerServerIdIndexRoute: typeof AuthedSettingsServerServerIdIndexRoute
}

const AuthedSettingsRouteRouteChildren: AuthedSettingsRouteRouteChildren = {
  AuthedSettingsAccountRoute: AuthedSettingsAccountRoute,
  AuthedSettingsDevicesRoute: AuthedSettingsDevicesRoute,
  AuthedSettingsPlayerRoute: AuthedSettingsPlayerRoute,
  AuthedSettingsQualityRoute: AuthedSettingsQualityRoute,
  AuthedSettingsSecurityRoute: AuthedSettingsSecurityRoute,
  AuthedSettingsSharingRoute: AuthedSettingsSharingRoute,
  AuthedSettingsTraktRoute: AuthedSettingsTraktRoute,
  AuthedSettingsIndexRoute: AuthedSettingsIndexRoute,
  AuthedSettingsSharingUserIdRoute: AuthedSettingsSharingUserIdRoute,
  AuthedSettingsServerServerIdActivityRoute:
    AuthedSettingsServerServerIdActivityRoute,
  AuthedSettingsServerServerIdDashboardRoute:
    AuthedSettingsServerServerIdDashboardRoute,
  AuthedSettingsServerServerIdGeneralRoute:
    AuthedSettingsServerServerIdGeneralRoute,
  AuthedSettingsServerServerIdLibrariesRoute:
    AuthedSettingsServerServerIdLibrariesRoute,
  AuthedSettingsServerServerIdLibraryRoute:
    AuthedSettingsServerServerIdLibraryRoute,
  AuthedSettingsServerServerIdMetadataRoute:
    AuthedSettingsServerServerIdMetadataRoute,
  AuthedSettingsServerServerIdNetworkRoute:
    AuthedSettingsServerServerIdNetworkRoute,
  AuthedSettingsServerServerIdOpensubtitlesRoute:
    AuthedSettingsServerServerIdOpensubtitlesRoute,
  AuthedSettingsServerServerIdTasksRoute:
    AuthedSettingsServerServerIdTasksRoute,
  AuthedSettingsServerServerIdTranscoderRoute:
    AuthedSettingsServerServerIdTranscoderRoute,
  AuthedSettingsServerServerIdTroubleshootingRoute:
    AuthedSettingsServerServerIdTroubleshootingRoute,
  AuthedSettingsServerServerIdIndexRoute:
    AuthedSettingsServerServerIdIndexRoute,
}

const AuthedSettingsRouteRouteWithChildren =
  AuthedSettingsRouteRoute._addFileChildren(AuthedSettingsRouteRouteChildren)

interface AuthedRouteChildren {
  AuthedSettingsRouteRoute: typeof AuthedSettingsRouteRouteWithChildren
  AuthedClaimRoute: typeof AuthedClaimRoute
  AuthedLinkRoute: typeof AuthedLinkRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedSearchRoute: typeof AuthedSearchRoute
  AuthedWatchlistRoute: typeof AuthedWatchlistRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedProfileHistoryRoute: typeof AuthedProfileHistoryRoute
  AuthedDiscoverIndexRoute: typeof AuthedDiscoverIndexRoute
  AuthedLibraryIndexRoute: typeof AuthedLibraryIndexRoute
  AuthedClaimApproveCodeRoute: typeof AuthedClaimApproveCodeRoute
  AuthedDiscoverMediaTypeTmdbIdRoute: typeof AuthedDiscoverMediaTypeTmdbIdRoute
  AuthedDiscoverPersonPersonIdRoute: typeof AuthedDiscoverPersonPersonIdRoute
  AuthedItemSourceIdItemIdRoute: typeof AuthedItemSourceIdItemIdRoute
  AuthedLibrarySourceIdLibraryIdRoute: typeof AuthedLibrarySourceIdLibraryIdRoute
  AuthedPlayerSourceIdItemIdRoute: typeof AuthedPlayerSourceIdItemIdRoute
  AuthedDiscoverTvTmdbIdSeasonSeasonNumberRoute: typeof AuthedDiscoverTvTmdbIdSeasonSeasonNumberRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedSettingsRouteRoute: AuthedSettingsRouteRouteWithChildren,
  AuthedClaimRoute: AuthedClaimRoute,
  AuthedLinkRoute: AuthedLinkRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedSearchRoute: AuthedSearchRoute,
  AuthedWatchlistRoute: AuthedWatchlistRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedProfileHistoryRoute: AuthedProfileHistoryRoute,
  AuthedDiscoverIndexRoute: AuthedDiscoverIndexRoute,
  AuthedLibraryIndexRoute: AuthedLibraryIndexRoute,
  AuthedClaimApproveCodeRoute: AuthedClaimApproveCodeRoute,
  AuthedDiscoverMediaTypeTmdbIdRoute: AuthedDiscoverMediaTypeTmdbIdRoute,
  AuthedDiscoverPersonPersonIdRoute: AuthedDiscoverPersonPersonIdRoute,
  AuthedItemSourceIdItemIdRoute: AuthedItemSourceIdItemIdRoute,
  AuthedLibrarySourceIdLibraryIdRoute: AuthedLibrarySourceIdLibraryIdRoute,
  AuthedPlayerSourceIdItemIdRoute: AuthedPlayerSourceIdItemIdRoute,
  AuthedDiscoverTvTmdbIdSeasonSeasonNumberRoute:
    AuthedDiscoverTvTmdbIdSeasonSeasonNumberRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
